<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AFb2tB/tc-custom/9781418580513.jpg?1728851632186" alt="This image is the cover for the book Aunt Bee's Delightful Desserts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Aunt Bee's Delightful Desserts
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Aunt Bee's Delightful Desserts</i> is filled with over 350 recipes for the lip-smacking desserts Aunt Bee and friends used to cook up on <i>The Andy Griffith Show</i>. From candies and cakes to rare photos from the show to trivia, this cookbook brings home all the sweet flavor of Mayberry. Illustrated and indexed.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ken Beck, Jim Clark
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?45ce4bb4